import { useState } from 'react';
import { Skeleton } from '@mui/material';
import { currencySymbols } from '@utils/static';
import { CopyToClipWhisper } from '@shared/ui/messages/CopyToClipWhisper';
import FreeCardsBadge from '@shared/ui/parts/FreeCardsBadge';
import { useTranslation } from 'react-i18next';
import { icons } from '@shared/static/icons';

const HIDDEN_VALUE = '✱'.repeat(11);

export default function ListData({ listData = [], isLoading = false }) {
  const { t } = useTranslation();
  const [revealedItems, setRevealedItems] = useState({});

  const toggleReveal = (index) => {
    setRevealedItems((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const isItemHidden = (item, index) =>
    item.isCopy && item.isHidden && !revealedItems[index];

  function renderValue(item, index) {
    if (item.component) return item.component;

    if (!item.isCopy) {
      return (
        <p className="listData__value">
          {item.value} {item.currency && currencySymbols[item.currency]}
        </p>
      );
    }

    if (isItemHidden(item, index)) {
      return (
        <button
          className="listData__value listData__value--reveal dashed-btn"
          onClick={() => toggleReveal(index)}
        >
          {icons['eye-visible']}
          {HIDDEN_VALUE}
        </button>
      );
    }

    return (
      <CopyToClipWhisper value={item.value} classes="listData__value">
        <p>{item.value}</p>
      </CopyToClipWhisper>
    );
  }

  if (isLoading) {
    return (
      <div className="listData">
        {listData.map((item, index) => (
          <div key={index} className="listData__item">
            <div className="listData__label secondary-text">{item.label}</div>
            <div className="line" />
            <Skeleton
              variant="text"
              width={120}
              height={14}
              className="listData__value listData__skeleton"
              sx={{ bgcolor: 'var(--basic-sep)', transform: 'none' }}
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="listData">
      {listData.map((item, index) => (
        <div key={index} className="listData__item">
          <div className="listData__label secondary-text">
            {item.balance && <div className={`dot dot--${item.balance}`}></div>}
            {item.icon && icons[item.icon]}
            {item.label}
            {item.showFreeCards && <FreeCardsBadge text={t('free_cards')} />}
          </div>
          <div className="line" />
          {renderValue(item, index)}
        </div>
      ))}
    </div>
  );
}
